export default {
    titulo: "Users",
    nuevo: "New user",
    editar: "Edit user",
    descatalogar: "Deactivate user",
    pregDescatalogar: "Are you sure you want to deactivate the user?",
    decatalogados: "Deactivated",
    restaurar: "Restore user",
    pregRestaurar: "Are you sure you want to restore the user?",
    admin: "Administrator",
    cambiarPass: "Change password",
    comision: "Commission",
    verSucursales: "View all branches",
    verSusOrdenes: "View only their orders",
    verReclamos: "View requests",
    verCosto: "View cost by project",
    esProveedor: "Is provider",
    esGestor: "Is manager",
    editarTodas: "Edit orders from other branches",
    esAdmin: "Is account administrator",
    labelGrupos: "Groups",
    msgErrorLimitePlan: "You cannot add more users because it exceeds the subscribed plan",
    grupos: {
        titulo: "User groups",
        nuevo: "New group",
        editar: "Edit group",
        eliminar: "Delete group",
        pregEliminar: "Are you sure you want to delete the user group?"
    },
    permisos: {
        label: "Permissions",
        Presupuesto: "Budget",
        "Mano de Obra": "Labor",
        Repuestos: "Spare Parts",
        "Eliminar Notas": "Delete Notes",
        "Ver Órdenes": "View Orders",
        "Ver Proveedores": "View Providers",
        "Ver Informes": "View Reports",
        "Eliminar Ordenes": "Delete Orders",
        "Eliminar Despachos": "Delete Dispatches",
        "Modificar Despachos": "Modify Dispatches"
    }
}
